<!--
    file type .....: HTML file: case-status.component.html
    Created By ....: ianday
    Date ..........: 3/6/24 
-->
<!--
    file type .....: HTML file: req-status.component.html
    Created By ....: ianday
    Date ..........: 11/10/23
-->
<div class="case-status-container">
    <div style="color:red;"><b>WARNING:</b> Changing the case status will close all open service requests for this case.
    This action cannot be undone.
    </div>
    <div class="local-top-section">
        <div class="dwform">
            <div class="dwform-row-gap"></div>

            <label class="label-field">Status:</label>
            <span class="form-required">*</span>

            <dw-dropdown
                    [id]="'statusId'"
                    [selectedItem]="selectedStatusId"
                    (itemSelected)="selectedStatusId = $event; onSelectStatus($event);"
                    [controlWidth]="'220px'"
                    [dataSource]="caseStatusList">
            </dw-dropdown>

            <div class="dwform-row-gap"></div>

            <label class="label-field" style="vertical-align: top">What It Means:</label>
            <span class="form-required"></span>

            <div class="label-field"
                   style="width: 280px; height: 50px;font-style:italic;font-size:9pt">{{selectedStatusDesc}}
            </div>
            <div class="dwform-row-gap"></div>

            <!-- Status Reason -->

            <mat-divider></mat-divider>
            <div class="dwform-row-gap"></div>
            <!-- Comments -->

            <label class="label-field" style="vertical-align: top;">Comments:</label>
            <span class="form-required"> </span>
            <textarea class="text-area-input text-area-override"
                      [(ngModel)]="statusComment"></textarea>
        </div>
    </div>

    <!----------------------->
    <!-- ERROR LINE --------->
    <!----------------------->

    <div class="error-line error-line-override" *ngIf="strErr.length > 0">{{strErr}}</div>
    <div class="error-line error-line-override-transparent" *ngIf="!strErr.length"></div>
    <!--
    <div class="error-line"
         style="position: relative; text-align:left; height: 23px; top: -5px; left: 2px;width:100%"
         [ngStyle]="{ 'background-color': (strErr.length > 0) ? 'lightcoral' : 'transparent'}"
        >{{strErr}}</div> -->
    <!----------------------->
    <!-- SAVE STRIP        -->
    <!----------------------->
    <div style="text-align:center; margin-top: 2px;">
        <button class="command-button" [disabled]="!enableSubmit"
                (click)="doPreSubmitActions()" matTooltip="Submit / save this entry"
                mat-button>
            <mat-icon>check_circle_outline</mat-icon>
            Submit
        </button>
        <button class="command-button"
                (click)="onCancelClicked()" matTooltip="Cancel without saving this entry" mat-button>
            <mat-icon>highlight_off</mat-icon>
            Cancel
        </button>
    </div>

</div>

<p-dialog header="Reclose Case" [focusOnShow]="false"
          [(visible)]="displayRecloseDlg" [modal]="true"
          [style]="{width: '450px', height: '290px'}"
          appendTo="body" [closeOnEscape]="false"
          [resizable]="false" [closable]="true" >
    <app-reclose-dialog #reclosedlg
          (submitClicked)="submitFromRecloseDialog($event);"
          (cancelClicked)="cancelFromRecloseDialog($event);"></app-reclose-dialog>
</p-dialog>